<template>
  <v-container>
    <v-row>
      <v-col class="py-0">
        <content-header
          :title="context.text"
          titlePlaceholder="Untitled Context"
          :description="context.description"
          descriptionPlaceholder="...add some general notes"
          @updateTitle="updateContextText({ text: $event })"
          @updateDescription="
            updateContextDescription({
              text: $event
            })
          "
          @traverseOut="traverse({ ...$event, toIndex: 0 })"
        >
          <v-col class="shrink py-0"><v-btn text @click="createNewItem">Add Section</v-btn></v-col>
        </content-header>
      </v-col>
    </v-row>
    <section-block
      v-for="section in sections"
      :ref="section.id"
      :key="section.id"
      :section="section"
    ></section-block>
  </v-container>
</template>

<script>
import SectionBlock from './SectionBlock';
import ContentHeader from '../ContentHeader';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { SectionBlock, ContentHeader },
  computed: {
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['context', 'userCanEdit', 'sections'])
  },
  methods: {
    ...mapActions('context', [
      'addSection',
      'update',
      'updateContextText',
      'updateContextDescription'
    ]),
    async createNewItem() {
      if (!this.userCanEdit) {
        return;
      }
      //  If we are making a child, put it at the end of the children, otherwise put right below this one.
      const args = { contextId: this.context.id };
      const id = await this.addSection(args);
      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs[id][0], { container: '#notepage-container' });
        this.$refs[id][0].focus();
      });
    }
  }
};
</script>

<style></style>
